import { SpeedDial } from "@material-ui/lab";
import styled from "styled-components";

const secondary = (props) => props.theme.palette.secondary;

export const CustomSpeedDial = styled(SpeedDial)`
  position: absolute;

  .MuiFab-root {
    max-width: 35px;
    max-height: 35px;
  }

  .MuiSpeedDial-actions {
    .MuiSpeedDialAction-fab {
      color: rgb(0 0 0 / 67%);
      background: ${secondary};
      transition: 0.3s ease;

      &:hover {
        background: #a4c3fe;
      }

      &.Mui-disabled {
        color: white !important;
        background-color: #e8e1d9 !important;
      }
    }
  }
`;

export const SpeedDialContainer = styled.div`
  margin: 0 auto;
  position: relative;
  width: 60px;
  height: 30px;
  transform: translate(10px, -35%);
`;
